import { IAbstractModel } from "model/abstract.model";
import { TDadosTransportador } from "pages/DadosTransportador";
import { FlowEventoNotaEmitidaTypeDTO } from "pages/evento-nota-fiscal/evento-nota-fiscal.model";
import { EventoNotaFiscalEmitida } from "pages/pagamento/pagamento.model";
import {
  IProduto,
  TipoDesconto,
} from "pages/registra-venda/registra-venda.model";
import { SituacaoConsignado } from "../situacao-consignado.model";

export interface FlowConsignadoDTO {
  uuid?: string | null;
  version?: number | null;
  numero?: number;
  cliente: IAbstractModel;
  vendedor: IAbstractModel | null;
  deposito: IAbstractModel | null;
  tabelaPreco: IAbstractModel | null;
  emissao?: string;
  dataAlterado?: string | null;
  situacao?: SituacaoConsignado;
  itensAbertos: FlowConsignadoItemDTO[];
  itensSimbolicos: FlowConsignadoItemDTO[];
  itensPendentes: FlowConsignadoItemDTO[];
  qtdValores?: FlowConsignadoQtdValoresDTO;
  transportador?: TDadosTransportador | null;
}

export interface FlowConsignadoQtdValoresDTO {
  quantidadeConsignada: number;
  quantidadeDevolvida: number;
  quantidadeVendida: number;
  saldo: number;
  valorConsignado: number;
  valorDevolvido: number;
  valorVendido: number;
  valorSaldo: number;
}

export type FlowConsignadoItemDTO = {
  sku: IProduto;
  situacao: SituacaoConsignado;
  situacaoOriginal: SituacaoConsignado;
  geradoPorDevolucao: boolean;
  quantidade: number;
  quantidadeDevolvida: number;
  quantidadeVendida: number;
  quantidadeCancelada: number;
  saldo: number;
  saldoAberto: number;
  valorUnitario: number;
  tipoDesconto: TipoDesconto;
  percentualDesconto: number;
  valorDesconto: number;
  valorTotalBruto: number;
  valorTotalLiquido: number;
  selecionado: boolean;
};

export type FlowConsignadoConsignarResponseDTO = {
  consignado: FlowConsignadoDTO;
  eventoNotaFiscal: EventoNotaFiscalEmitida | null;
  eventoNotaType: FlowEventoNotaEmitidaTypeDTO | null;
  chaveAcesso: string;
  urlDanfe?: string;
};

export const flowConsignadoItemOf = (sku: IProduto): FlowConsignadoItemDTO => {
  return {
    sku,
    situacao: SituacaoConsignado.ABERTO,
    situacaoOriginal: SituacaoConsignado.ABERTO,
    geradoPorDevolucao: false,
    quantidade: 1,
    quantidadeDevolvida: 0,
    quantidadeVendida: 0,
    quantidadeCancelada: 0,
    saldo: 0,
    saldoAberto: 0,
    valorUnitario: sku.preco,
    tipoDesconto: TipoDesconto.PERCENTUAL,
    percentualDesconto: 0,
    valorDesconto: 0,
    valorTotalBruto: sku.preco,
    valorTotalLiquido: sku.preco,
    selecionado: true,
  };
};

export type FlowConsignadoObservacaoDTO = {
  uuid: string;
  observacao: string;
};
